module.exports = __webpack_public_path__ + "static/media/sheer-allure.715e5877.png";